import * as types from './company-contexts.types';
import * as constants from './company-contexts.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const companyContextsReducer = generateResourceReducer<types.ICompanyContext>({
  STORE: constants.STORE_COMPANY_CONTEXT,
  CLEAR: constants.CLEAR_COMPANY_CONTEXT,
});
